ko.bindingHandlers["capitalizedText"] =
   "update": (element, valueAccessor) ->
      text = ko.unwrap(valueAccessor())
      capitalText = ko.observable(text.charAt(0).toUpperCase() + text.slice(1))
      ko.bindingHandlers.text.update(element, capitalText)